import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import * as api from "../../../services/apiService";
import './LandingPage.scss';

function LandingPage() {
  const [data, setData] = useState([]);
  const image1 = "/images/testPic.jpg";

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await api.getComplaintAll();
        const result = await response.json();
        console.log(result)
        setData(result);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }

    fetchData();
  }, []);

  return (
    <div className="container my-5 item-grid">
      {data.map((item) => {
        return (
          <Link
            to={`/item/${item.id}`}
            key={item.id}
            className="item rounded"
          >
            <div class="card border-0">
              <img src={api.baseUrl + item.imageLink} className="card-img-top" alt={item.title} />
              <div class="card-body rounded">
                <p class="card-title m-0">{item.title}</p>
              </div>
            </div>
          </Link>
        );
      })}
    </div>
  );
}

export default LandingPage;
